import React, { useState, useEffect } from "react";
import DashboardNav from "../DashboardNavbar/DashboardNav";
import icon_people from "../../assets/img/icon_people.png";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  TablePagination,
  MenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getAllOrders } from "../../api/Api";
const TransactionDashboard = () => {
  const theme = useTheme();
  const [userName, setUserName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [ordersData, setOrdersData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalTransaction, setTotalTransaction] = useState(0);
  const [todayOnlineTransaction, setTodayOnlineTransaction] = useState(0);
  const [totalTodaysOrder, setTotalTodaysOrder] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Fetch data from API
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await getAllOrders();
        const orders = response.data.orders;

        // Update state with fresh API data
        setOrdersData(orders);
        setTotalOrders(response.data.totalOrders);

        // Save to localStorage for fallback use
        localStorage.setItem("AllOrders", JSON.stringify(orders));
        localStorage.setItem(
          "totalOrders",
          response.data.totalOrders.toString()
        );
      } catch (error) {
        console.error("Error fetching orders:", error);
        // Fallback to localStorage if API fails
        const savedOrders = JSON.parse(localStorage.getItem("AllOrders"));
        const savedTotalOrders = localStorage.getItem("totalOrders");

        if (savedOrders) setOrdersData(savedOrders);
        if (savedTotalOrders) setTotalOrders(parseInt(savedTotalOrders, 10));
      }
    };

    fetchOrders();
  }, []);

  // Calculate totals based on fresh or fallback data
  useEffect(() => {
    const currentDateUTC = new Date().toISOString().split("T")[0]; // Current date in UTC
    const total = ordersData
      .filter((order) => {
        const orderDateUTC = new Date(order.placed_at)
          .toISOString()
          .split("T")[0]; // Order date in UTC
        return (
          order.order_status === "Delivered" && orderDateUTC === currentDateUTC
        );
      })
      .reduce((sum, order) => sum + (order.total_price || 0), 0);

    const onlineTotal = ordersData
      .filter((order) => {
        const orderDateUTC = new Date(order.placed_at)
          .toISOString()
          .split("T")[0]; // Order date in UTC
        return (
          order.order_status === "Delivered" &&
          orderDateUTC === currentDateUTC &&
          order.payment_type === "upi"
        );
      })
      .reduce((sum, order) => sum + (order.total_price || 0), 0);

    const todaysOrdersCount = ordersData.filter((order) => {
      const orderDateUTC = new Date(order.placed_at)
        .toISOString()
        .split("T")[0]; // Order date in UTC
      return orderDateUTC === currentDateUTC;
    }).length;

    setTotalTransaction(total);
    setTodayOnlineTransaction(onlineTotal);
    setTotalTodaysOrder(todaysOrdersCount);
  }, [ordersData]);

  const filterTransactions = () => {
    const filtered = ordersData.filter((order) => {
      const matchesUserName = userName
        ? order.user_name.toLowerCase().includes(userName.toLowerCase())
        : true;

      const orderDate = new Date(order.placed_at);
      const fromDateObj = fromDate ? new Date(fromDate) : null;
      const toDateObj = toDate ? new Date(toDate) : null;

      const matchesFromDate = fromDate ? orderDate >= fromDateObj : true;
      const matchesToDate = toDate ? orderDate <= toDateObj : true;

      const matchesPaymentStatus = paymentStatus
        ? order.payment_status === paymentStatus
        : true;

      return (
        matchesUserName &&
        matchesFromDate &&
        matchesToDate &&
        matchesPaymentStatus
      );
    });
    setFilteredData(filtered);
  };
  // Automatically filter whenever input or ordersData changes
  useEffect(() => {
    filterTransactions();
  }, [userName, fromDate, toDate, paymentStatus, ordersData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Box sx={{ height: "100vh" }}>
      {/* Navbar */}
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <DashboardNav />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "180px",
          left: 0,
          right: 0,
          px: 1,
          width: "90vw",
          margin: "auto",
          color: "#888585",
        }}
      >
        <Typography
          sx={{
            fontSize: "32px",
            lineHeight: "34.85px",
            fontWeight: "500",
            fontFamily: theme.palette.typography,
          }}
          variant="h5"
          gutterBottom
        >
          Transactions
        </Typography>
        {/* Transaction Cards */}
        <Grid container spacing={1}>
          {/* Changed spacing from 2 to 1 */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: "#E0FFF2",
                borderRadius: "10px",
                color: "#297643",
                width: "80%",
                height: "80%",
                padding: "20px",
                boxShadow: "0px 4px 4px 0px #9AEFB6",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#297643",
                        marginRight: 1,
                        fontSize: "24px",
                        marginBottom: "15px",
                      }}
                      variant="h6"
                      gutterBottom
                    >
                      Today's Total Order
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"2rem"}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "500",
                          color: "#888585",
                          marginRight: 1,
                          fontSize: "24px",
                          marginBottom: "5px",
                        }}
                      >
                        {totalTodaysOrder}
                      </Typography>
                      <Typography color="#297643" sx={{ marginBottom: "5px" }}>
                        +2.3%
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#36AB5D",
                      borderRadius: "50%",
                      width: "80px", // Adjust the width as needed
                      height: "78px", // Adjust the height as needed
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={icon_people}
                      alt=""
                      style={{
                        width: "70%", // Adjust size to fit within the circle
                        height: "70%", // Adjust size to fit within the circle
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: "#DFD8FF",
                borderRadius: "10px",
                color: "#3D2C8B",
                width: "80%",
                padding: "20px",
                height: "80%",
                boxShadow: "0px 4px 4px 0px #947FF6",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#3D2C8B",
                        marginRight: 1,
                        fontSize: "24px",
                        marginBottom: "15px",
                      }}
                      variant="h6"
                      gutterBottom
                    >
                      Today's Transaction
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"2rem"}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "500",
                          color: "#888585",
                          fontSize: "24px",
                        }}
                      >
                        {totalTransaction}
                      </Typography>
                      <Typography color="#297643" sx={{ marginBottom: "5px" }}>
                        +2.3%
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#3D2C8B",
                      borderRadius: "50%",
                      width: "78px", // Adjust the width as needed
                      height: "80px", // Adjust the height as needed
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={icon_people} // Ensure icon_people is imported
                      alt=""
                      style={{
                        width: "70%", // Adjust size to fit within the circle
                        height: "70%", // Adjust size to fit within the circle
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: "#D8FCFF",
                borderRadius: "10px",
                color: "#114C78",
                width: "80%",
                padding: "20px",
                height: "80%",
                boxShadow: "0px 4px 4px 0px #62AFB6",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#114C78",
                        fontWeight: "500",
                        marginRight: 1,
                        fontSize: "24px",
                        marginBottom: "15px",
                      }}
                      gutterBottom
                    >
                      Today's Online Transaction
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"2rem"}>
                      <Typography
                        variant="h4"
                        sx={{
                          color: "#888585",
                          fontWeight: "500",
                          marginRight: 1,
                          fontSize: "24px",
                          marginBottom: "15px",
                        }}
                      >
                        {todayOnlineTransaction}
                      </Typography>
                      <Typography color="#297643" sx={{ marginBottom: "5px" }}>
                        +2.3%
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#20838C",
                      borderRadius: "50%",
                      width: "78px",
                      height: "80px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={icon_people} // Ensure icon_people is imported
                      alt=""
                      style={{
                        width: "70%", // Adjust size to fit within the circle
                        height: "70%", // Adjust size to fit within the circle
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Transactions Details */}
        <Box sx={{ mt: 4, color: "#888585" }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: "32px",
              lineHeight: "34.85px",
              fontWeight: "500",
              fontFamily: theme.palette.typography,
              marginTop: "1vh",
              marginBottom: "5vh",
            }}
            gutterBottom
          >
            Transactions Details
          </Typography>

          {/* Filter Fields */}
          <Grid container spacing={2} sx={{ mb: 2, alignItems: "center" }}>
            {/* User Name Filter */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="User Name"
                variant="outlined"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </Grid>

            {/* From Date Filter */}
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="From Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Grid>

            {/* To Date Filter */}
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="To Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Grid>

            {/* Payment Status Filter */}
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Payment Status"
                variant="outlined"
                value={paymentStatus}
                onChange={(e) => setPaymentStatus(e.target.value)}
                select
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Paid">Paid</MenuItem>
                <MenuItem value="Unpaid">Unpaid</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          {/* Transactions Table */}
          <TableContainer
            component={Paper}
            sx={{ mt: 4, fontFamily: theme.typography.fontFamily }}
          >
            <Table>
              <TableHead>
                <TableRow
                  sx={{ backgroundColor: theme.palette.primary.light, p: 4 }}
                >
                  <TableCell sx={{ color: "#fff" }}>Sl No</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Order Id</TableCell>
                  <TableCell sx={{ color: "#fff" }}>User Name</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Transaction Id</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Order Placed On</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Amount</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Payment Mode</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Payment Status</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Delivery Status</TableCell>
                  {/* <TableCell sx={{ color: "#fff" }}>Actions</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData
                  .slice()
                  .reverse() // Reverse the entire filtered data array
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Apply pagination
                  .map((row, index) => (
                    <TableRow key={row._id}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>{row._id.slice(-4)}</TableCell>
                      <TableCell>{row.user_name}</TableCell>
                      <TableCell>{row.user_id}</TableCell>
                      {/* <TableCell>
                        {new Date(row.placed_at).toLocaleString()}
                      </TableCell> */}
                      <TableCell>
                        {
                          new Date(row.placed_at)
                            .toISOString()
                            .replace("T", " ")
                            .split(".")[0]
                        }
                      </TableCell>

                      <TableCell>{`₹${row.total_price}`}</TableCell>
                      <TableCell>{row.payment_type}</TableCell>
                      <TableCell
                        sx={{
                          color:
                            row.payment_status === "Success"
                              ? theme.palette.primary.light
                              : row.payment_status === "Unpaid"
                              ? "red"
                              : "#000",
                        }}
                      >
                        {row.payment_status}
                      </TableCell>
                      <TableCell
                        sx={{
                          color:
                            row.order_status === "Dispatched" ||
                            row.order_status === "Delivered" ||
                            row.order_status === "Shipped"
                              ? theme.palette.primary.light
                              : row.order_status === "Pending" ||
                                row.order_status === "Cancelled"
                              ? "red"
                              : "#000",
                        }}
                      >
                        {row.order_status}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 25, 35, 55, 65, 85]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default TransactionDashboard;
